define('plugin/membership/view/MembershipFilterCollectionView',['require','marionette','plugin/membership/view/MembershipFilterItemView'],function (require) {

    var CollectionView = require('marionette').CollectionView;
    var MembershipFilterItemView = require('plugin/membership/view/MembershipFilterItemView');

    return CollectionView.extend({

        childView: MembershipFilterItemView,

        childViewOptions: function (model, index) {
            var field = this.getOption('field');
            var filter = this.getOption('filterData');

            var checked = false;

            if (filter && filter[field]) {
                checked = _.indexOf(filter[field], model.get('id')) !== -1;
            }

            return {
                'checked': checked,
                'field': field
            };
        },

    });

});
